import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { TranslateLoader } from '@ngx-translate/core';
import {AppConfigService} from './appconfig.service';
import {map} from 'rxjs/operators';

@Injectable()
export class TranslationService implements TranslateLoader {

  constructor(private http: HttpClient, private configService: AppConfigService) { }

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`${this.configService.configData.mediaUrl}/traduction/${lang}.json`)
      .pipe(map((response: JSON) => {
        return response;
      }));
  }
}
